<div class="position-container">
  <div class="position-container__menu-bar">
    Positions
    <button
      class="position-container__button-close"
      (click)="closePosition(false)"
    ></button>
  </div>
  <div class="position-container__main">
    <clr-tabs>
      <clr-tab *ngIf="tradesEnabled">
        <button
          clrTabLink
          (click)="hasTradesBeenClicked = true; tabSelected = true"
        >
          Trades
        </button>
        <ng-template [(clrIfActive)]="showTrades">
          <clr-tab-content class="tab-section">
            <app-trades-grid
              (tradesLoaded)="onLoadTrades($event)"
              [hasTradesBeenClicked]="hasTradesBeenClicked"
            ></app-trades-grid>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab>
        <button clrTabLink (click)="tabSelected = true">Blotter</button>
        <ng-template [(clrIfActive)]="showBlotter">
          <clr-tab-content class="tab-section">
            <app-blotter
              (tradesLoaded)="onLoadTrades($event)"
              (getRfqTimeline)="getRfqTimeline($event)"
              [loginState]="loginState$ | async"
            >
            </app-blotter>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="showRFQs">
        <button
          clrTabLink
          (click)="tabSelected = true"
          class="incoming-rfq__btn"
        >
          Incoming RFQs
        </button>
        <ng-template [(clrIfActive)]="showRfqTab">
          <clr-tab-content class="tab-section">
            <app-provider-rfqs
              (tradesLoaded)="onLoadTrades($event)"
            ></app-provider-rfqs>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="enableWhiteLabelTradingRules">
        <button clrTabLink (click)="tabSelected = true" class="wl-blotter__btn">
          WL Blotter
        </button>
        <ng-template [(clrIfActive)]="showWhiteLabelBlotter">
          <clr-tab-content class="tab-section">
            <app-white-label-blotter></app-white-label-blotter>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="enableWhiteLabelTradingRules">
        <button clrTabLink (click)="tabSelected = true" class="wl-blotter__btn">
          Delta Hedges
        </button>
        <ng-template [(clrIfActive)]="showDeltaHedges">
          <clr-tab-content class="tab-section">
            <app-delta-hedges></app-delta-hedges>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="isEventsBlotterAccessAuthorized | async">
        <button clrTabLink (click)="tabSelected = true" class="wl-blotter__btn">
          Events
        </button>
        <ng-template [(clrIfActive)]="showEventsBlotter">
          <clr-tab-content class="tab-section">
            <app-events-blotter></app-events-blotter>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="isRisksBlotterAccessAuthorized | async">
        <button clrTabLink (click)="tabSelected = true" class="wl-blotter__btn">
          Risks
        </button>
        <ng-template [(clrIfActive)]="showRisksBlotter">
          <clr-tab-content class="tab-section">
            <app-risks-blotter></app-risks-blotter>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="isPnlBlotterAccessAuthorized | async">
        <button clrTabLink (click)="tabSelected = true" class="wl-blotter__btn">
          PNL
        </button>
        <ng-template [(clrIfActive)]="showPNLBlotter">
          <clr-tab-content class="tab-section">
            <app-pnl-blotter></app-pnl-blotter>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="isLifecycleBlotterAccessAuthorized | async">
        <button clrTabLink (click)="tabSelected = true" class="wl-blotter__btn">
          Lifecycle
        </button>
        <ng-template [(clrIfActive)]="showPNLBlotter">
          <clr-tab-content class="tab-section">
            <app-lifecycle-blotter></app-lifecycle-blotter>
          </clr-tab-content>
        </ng-template>
      </clr-tab>

      <clr-tab *ngIf="isCashFlowsBlotterAccessAuthorized | async">
        <button clrTabLink (click)="tabSelected = true" class="wl-blotter__btn">
          Cash Flows
        </button>
        <ng-template [(clrIfActive)]="showCashFlowsBlotter">
          <clr-tab-content class="tab-section">
            <app-cash-flows-blotter></app-cash-flows-blotter>
          </clr-tab-content>
        </ng-template>
      </clr-tab>
    </clr-tabs>
  </div>
</div>
